// extracted by mini-css-extract-plugin
module.exports = {"container":"NativeShare_container__okhFj","containerIcon":"NativeShare_containerIcon__uqBzs","icon":"NativeShare_icon__c2KQS"};